export default __webpack_public_path__ + "static/Isolieren-514ab90cd7e4d3ad55b37ee0441484c3.jpg";